<template>
    <div>
        <v-dialog v-model="pmmoderationdetaildialog" max-width="1200px">
            <v-card>
                <v-card-title>
                    <template v-if="formData.staffcode && formData.staffname">
                        {{ $t('pmmoderation.editresult', { staffcode: formData.staffcode, staffname: formData.staffname }) }}
                    </template>
                    <template v-else>
                       Loading...
                    </template>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>                                    
                            <v-col cols="12" sm="12" md="12" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.name')"
                                    type="text"
                                    v-model="formData.staffname"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="5" sm="5" md="5" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.staffno')"
                                    type="text"
                                    v-model="formData.staffcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1" sm="1" md="1" class="mt-n4">
   
                            </v-col>
                            <v-col cols="6" sm="6" md="6" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('columns.company')"
                                    type="text"
                                    v-model="formData.companyname"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmmoderation.periodfromdate')"
                                    type="date"
                                    v-model="formData.startdate"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmmoderation.perioduntildate')"
                                    type="date"
                                    v-model="formData.enddate"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('pmassementrecord.finalscore')"
                                    type="text"
                                    v-model="formData.finalscore"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label="$t('Setuprankmapset.rank')"
                                    type="text"
                                    v-model="formData.rank"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label="$t('pmassementrecord.finalrank')"
                                    type="text"
                                    :items="ratingList"
                                    hide-selected
                                    :rules="[rules.required]"
                                    v-model="formData.finalrank"
                                    item-value="value"
                                    item-text="text"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n4">
                                <v-text-field
                                    outlined
                                    :label="$t('pmmoderation.moderationremark')"
                                    type="text"
                                    v-model="formData.moderationremark"
                                    dense
                                ></v-text-field>
                            </v-col>    
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{errMsg}}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closePmAssessmentRecordDetailInput">{{$t('button.cancel')}}</v-btn>
                    <v-btn color="green darken-1" text @click="savePmAssessmentRecordDetailInput">{{$t('button.save')}}</v-btn>
                </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="crud-toolbar" style="display:flex;justify-content:flex-end;align-items:center;gap:8px;padding:8px 4px;">
                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                  CSV
                </button>
                <div class="gv-search" style="display:flex;align-items:center;gap:6px;background:#F8FAFF;border:1px solid #E8EDF5;border-radius:8px;padding:4px 10px;">
                    <v-icon size="16" style="color:#94A3B8;">mdi-magnify</v-icon>
                    <input v-model="search" type="text" placeholder="Search..." style="border:none;background:transparent;outline:none;font-size:0.85rem;color:#1E293B;width:180px;" />
                </div>
        </div>
        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            :search="search"
            class="elavation-1"
:sort-by="['code']"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    class="ml-2 mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
            </template>
        </v-data-table>
        </div>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
        <!-- <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="deleteItemHandlerAction"
                v-on:cancelConfirm="isConfirm = !isConfirm"
            />
        </div> -->
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
//import ConfirmDialog from "../../../components/common/ConfirmDialog";
//import moment from 'moment';

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        //"app-confirm": ConfirmDialog,
    },

    data() {
        return {
            //publicPath: process.env.BASE_URL,
            search: "",
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            pmmoderationdetaildialog: false,
            detailItem: this.parentObject.detailItem,

            formData: {
                id: null,
                pmassessmentrecordid: this.parentObject.pmassessmentrecordid,
                staffname: null,
                staffcode: null,
                companyname:null,
                finalscore: null,
                rank:null,
                finalrank: null,
                startdate: null,
                enddate: null,
                moderationremark: null,
                updatedby: this.$store.getters.userId,
                rectimestamp: null,
                stamp: null,
                
            },
            ratingList: [],
            ratingFullItem:[],

            isEdit: this.parentObject.isEdit,
            isAdvanceEdit: this.parentObject.isAdvanceEdit,
            isErr: false,
            errMsg: '',
            //isConfirm: false,
            //messageConfirm:'',
            //selectedItem: null, 
        }
    },

    methods: {
        modifyItemHandler(item) {
            if (!item) {
                console.error("⚠️ No item selected for modification!");
                return;
            }
            this.isEdit = true;
            // Assign item data safely
            this.formData = {
                ...item,
                startdate: item.startdate || "N/A", //assessment record startdate OR hire date of employee, depend on query
                enddate: item.enddate || "N/A",   //assessment record enddate OR ceassation date of employee
                staffname: item.staffname || "N/A",
                staffcode: item.staffcode || "N/A",
                companyname: item.companyname || "N/A",
                finalrank: item.finalrank ? String(item.finalrank) : null, // Convert to string for v-autocomplete
                moderationremark: item.moderationremark,
                updatedby: this.$store.getters.userId,
                stamp: item.stamp,
            };
            // Ensure Vue updates the form correctly
            this.$nextTick(() => {
                this.pmmoderationdetaildialog = true;
            });
        },

        // deleteItemHandler(item) {
        //     this.messageConfirm="Are you sure you want to delete this Assessment Result for " + item.staffname + "?";
        //     this.selectedItem = item;
        //     this.isConfirm=true;
            
        // },

        // deleteItemHandlerAction(){

        //     if (!this.selectedItem) {
        //         console.error(" No item selected for deletion!");
        //         return;
        //     }
        //     const vm = this;

        //     if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        //         console.error("❌ No permission to delete");
        //         return false;
        //     }

        //     this.$store.dispatch('delete', {
        //         url: "/performanceassessmentrecorddetail/"+ vm.selectedItem.id // Send ID as a parameter
        //     })
        //     .then(() => {
        //         const index = vm.detailItem.findIndex(detail => detail.id === vm.selectedItem.id);
        //         if (index !== -1) {
        //             vm.detailItem.splice(index, 1);
        //         }
        //         vm.selectedItem = null; // 🔹 Clear after deletion
        //     })
        //     .catch((err) => {
        //         console.error("❌ Error deleting:", err);
        //         vm.errMsg = err;
        //     });
            
        //     this.isConfirm = false;  // 🔹 Close confirmation dialog
        // },
        
        // async onAdvanceEditItem(item) { //load the reviewer detail
        //     if (!item) {
        //         console.error("⚠️ No item selected!");
        //         return;
        //     }

        //     this.isEdit = true;
        //     this.formData = {
        //         ...item,
        //         staffname: item.staffname || "N/A",
        //         staffcode: item.staffcode || "N/A",
        //     };

        //     try {
        //         const res = await this.$store.dispatch("get", {
        //             url: `/reviewersname/${item.pmassessmentrecordid}/${item.staffid}`
        //         });

        //         if (res.data && res.data.reviewers) {
        //             this.reviewerList = res.data.reviewers.map(reviewer => ({
        //                 ...reviewer,
        //                 reviewfromdate: reviewer.reviewfromdate
        //                     ? moment(reviewer.reviewfromdate).format('YYYY-MM-DD')
        //                     : null,
        //                 reviewuntildate: reviewer.reviewuntildate
        //                     ? moment(reviewer.reviewuntildate).format('YYYY-MM-DD')
        //                     : null,
        //             }));

        //         } else {
        //             console.warn("⚠️ No reviewers found!");
        //             this.reviewerList = [];
        //         }
        //     } catch (err) {
        //         console.error("❌ Error fetching reviewers:", err);
        //         this.reviewerList = [];
        //     }

        //     this.$nextTick(() => {
        //         this.pmassessmentrecorddetailreviewerdialog = true;
        //     });
        // },

        async savePmAssessmentRecordDetailInput() {
            try {
                if (this.isEdit) { // Edit
                    if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                        console.error("❌ No permission to edit");
                        return false;
                    }
                    const res = await this.$store.dispatch('put', {
                        url: "/performanceassessmentrecorddetailbymoderation/" + this.formData.id,
                        payload: this.formData // we only update the finalrank and the moderation remark
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {//completed update

                        // 🔄 **Update UI without reloading**
                        const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                        if (index !== -1) {
                            this.$set(this.detailItem, index, { ...this.formData }); // Ensure reactivity
                        }

                        this.pmmoderationdetaildialog = false;
                        this.isEdit = false;
                        this.resetSelections();

                        // Emit event to notify parent to reload rank card
                        this.$emit("updateRankCard");
                    }
                }
            } catch (err) {
                // ✅ **Handle 409 Conflict Error Gracefully**
                if (err.response && err.response.status === 409) {
                    this.isErr = true;
                    this.errMsg = "⚠️ The record has been modified recently. Please refresh and try again.";
                } else {
                    this.isErr = true;
                    this.errMsg = err.message || "❌ An unexpected error occurred.";
                }
                console.error("❌ Error in processing:", err);
            }
        },

        closePmAssessmentRecordDetailInput() {
            this.pmmoderationdetaildialog = false;
            this.isErr = false;
            this.isEdit = false;
            // reset the form fields
            this.resetSelections();
        },


        resetSelections() {
            this.formData = {
                id:null,
                pmassessmentrecordid: this.parentObject.pmassessmentrecordid,
                updatedby: this.$store.getters.userId,

                pmmoderationdetaildialog: false,
         
            }
        },

        async loadRankMapSetOption()
        {   
            const vm = this;
            this.$store.dispatch('get', {url: "/rankmapsetdetails/" + this.parentObject.ratingid})
            .then(function (res) {
                vm.ratingFullItem = res.data.rec;

                vm.ratingList = []; // Clear before populating
                for (let i = 0; i < vm.ratingFullItem.length; i++) {
                    vm.ratingList.push({
                        text: vm.ratingFullItem[i].rank,
                        value: String(vm.ratingFullItem[i].rank),//  Convert to string
                    });
                }
            })
            .catch(function (err) {
                vm.errMsg = err;
                console.error("❌ Error loading Ranking set detail", err);
            });
        },

        //This 3 is method use to export CSV
        objectToCSV(data) {
        const csvRows = [];

        //get header
        const headers = Object.keys(data[0]);
        //const headers = this.titles
        csvRows.push(headers.join(","));

        //loop over the rows
        for (const row of data) {
            const values = headers.map((header) => {
            const escaped = ("" + row[header]).replace(/"/g, '\\"');
            return `"${escaped}"`;
            });
            csvRows.push(values.join(","));
        }
        return csvRows.join("\n");
        },
        download(data) {
        const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", this.parentObject.pageTitle + ".csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        },
        async getCSV() {
        let titles = this.parentObject.tabHeader;
        let item = this.detailItem;
        let data = [];
        let obj2 = {};

        titles.forEach((element1) => {
            let x = element1.text;
            obj2[x] = element1.value;
        });

        item.forEach((element1) => {
            let obj = {};
            titles.forEach((element2) => {
            if (element2.value != "action") {
                let key = element2.text;
                obj[key] = element1[element2.value];
            }
            });
            data.push(obj);
        });

        const csvData = this.objectToCSV(data);
        this.download(csvData);
        },
    },

    async mounted() {
        try {
            await this.loadRankMapSetOption();
        } catch (err) {
            this.isErr = true;
            this.errMsg = err.message || "An error occurred while loading data";
            console.error("❌ Error in mounted:", err);
        }
    },

}
</script>

<style scoped>
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }
</style>